import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { setEnv } from "apis";
import "./App.css";
import "./index.css";
import QueueDashboard from "./pages/queue-dashboard";

const queryClient = new QueryClient();

setEnv({
  env: import.meta.env.VITE_APP_ENV === "PROD" ? "PROD" : "DEV",
  // env: "PROD",
  clientId: "doc-web",
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <div className="dr-font-lato flex w-screen h-screen dr-bg-darwin-touch-neutral-0">
        <QueueDashboard />
      </div>
    </QueryClientProvider>
  );
}

export default App;
